module.exports = __webpack_public_path__ + "img/140.a4fac658.jpg";